const definitions = {
  ageofpeople: 'multivalue',
  agreements: 'multivalue',
  collections: 'multivalue',
  compositions: 'multivalue',
  ethnicity: 'multivalue',
  events: 'multivalue',
  filmdefinition: 'multivalue',
  framerate: 'multivalue',
  imagetechnique: 'multivalue',
  locations: 'multivalue',
  numberofpeople: 'multivalue',
  orientations: 'multivalue',
  specificpeople: 'multivalue',
  viewpoint: 'multivalue',
  editorialsources: 'multivalue',

  bwonly: 'boolean',
  embeddable: 'boolean',
  excludenudity: 'boolean',
  groupbyevent: 'boolean',
  istockexclusive: 'boolean',
  videotemplatecategory: 'multivalue',
  videotemplateappversion: 'multivalue',
};

export function isBooleanParameter(parameterName) {
  return definitions[parameterName] === 'boolean';
}

export function isMultivalueParameter(parameterName) {
  return definitions[parameterName] === 'multivalue';
}

export function getDefinition(parameterName) {
  if (typeof definitions[parameterName] === 'undefined') {
    return { name: parameterName, type: 'singlevalue' };
  }
  return { name: parameterName, type: definitions[parameterName] };
}
